export default "__VITE_ASSET__bba16fdb__"